export default __webpack_public_path__ + "static/media/listing_bathroom.87b1c439.svg";